module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/calculator-cb6894e98d3effee9b7f0045d7ca6b3b.svg";